import {addI18nMap} from './i18n';

addI18nMap({
    'zh_cn': {
        confirm: '确定',
        save: '保存',
        cancel: '取消',
        delete: '删除',
        reset: '重置',
        add: '添加',
        copy: '复制',
        close: '关闭',
    },
    'zh_tw': {
        confirm: '確定',
        save: '儲存',
        cancel: '取消',
        delete: '刪除',
        reset: '重置',
        add: '添加',
        Copy: '複製',
        close: '關閉',
    },
    en: {
        confirm: 'Confirm',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        reset: 'Reset',
        add: 'Add',
        copy: 'Copy',
        close: 'Close',
    },
});
